exports = module.exports = require("./../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "#intercom-container{display:none}.dropdown{display:-webkit-box;display:-moz-flex;display:-ms-flexbox;display:flex;-webkit-box-direction:normal;-webkit-box-orient:vertical;-moz-flex-direction:column;-ms-flex-direction:column;flex-direction:column}.dropdown *{padding:.5rem}.dropdown label{font-size:1rem;color:#555;padding-left:0;font-weight:700}.dropdown select{background-color:#fff;font-size:1rem;border-radius:0;min-height:3rem;padding:0;box-shadow:inset 0 1px 1px rgba(0,0,0,.075);padding-left:1rem;border-color:#afafaf}.dropdown select:focus{outline:none!important}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?localIdentName=[local]--[hash:base64:8]!./~/sass-loader!./src/components/shared/dropdown/styles.scss
// module id = 1024
// module chunks = 0